import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { useOfferStore as n } from "../../../../store/index.mjs";
import { StripeExpressCheckout as p } from "./stripe-express-checkout.mjs";
import { useStripe as m, PaymentElement as a } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { PaymentMethodEnum as l } from "@systemeio/ui";
function y(t) {
  const r = m(), { availablePaymentMethods: i } = n();
  if (!r) return null;
  const o = i.includes(l.stripe_applepay);
  return /* @__PURE__ */ s("div", { children: [
    o && /* @__PURE__ */ e(p, { ...t }),
    /* @__PURE__ */ e(
      a,
      {
        options: {
          fields: {
            billingDetails: {
              address: "never"
            }
          }
        }
      }
    )
  ] });
}
export {
  y as StripeCardDetails
};
